import React from 'react';

const ExtensionsView = () => {
  return <div>ExtensionsView</div>;
};

export default ExtensionsView;
